<template>
    <v-card :loading="bookingLoading">
        <v-card-title>
            <v-row>
                <v-col cols="12" md="4">
                    Relatório de Reservas
                </v-col>
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="4" class="text-right">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }" >
                            <v-btn
                                v-on="on"
                                color="white"
                                :loading="awaitingReportDownload"
                                @click="emitDownloadReport()"
                            >
                                <v-icon color="primary">mdi-download</v-icon>
                            </v-btn>
                        </template>
                        Baixar Relatório em XLS
                    </v-tooltip>
                    <v-btn
                        width="50%"
                        color="#f2c037"
                        class="filter-btn"
                        @click="filterDrawer = !filterDrawer"
                    >
                        <v-icon class="mr-2" small>mdi-filter-outline</v-icon>
                        Filtros {{filteredResult ? '(ativo)' : ''}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <report-cards
                :report-data="bookingReportData"
            />
        </v-card-text>
        <filter-drawer
            :show-drawer="filterDrawer"
            @clear-filter="clearFilter()"
            @apply-filter="applyFilter()"
        >
            <template v-slot:form>
                <v-form>
                    <v-row>
                        <v-col cols="12" md="12">
                            <p class="mb-2 filter-label">Hotel</p>
                            <v-autocomplete
                                outlined
                                v-model="filterHotelId"
                                :items="hotelList"
                                item-text="name"
                                item-value="id"
                                :loading="hotelLoading"
                                :search-input.sync="filterHotel"
                                no-data-text="Nenhum resultado encontrado"
                                autocomplete="off"
                                color="secondary"
                                placeholder="Minimo de 5 caracteres para buscar"
                                item-color="secondary"
                                clearable
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <p class="mb-2 filter-label">Ponto de Venda</p>
                            <v-autocomplete
                                outlined
                                v-model="filterPointOfSaleId"
                                :items="pointOfSaleList"
                                :item-text="pointOfSaleText"
                                item-value="id"
                                :loading="pointOfSaleLoading"
                                :search-input.sync="filterPointOfSale"
                                no-data-text="Nenhum resultado encontrado"
                                autocomplete="off"
                                color="secondary"
                                item-color="secondary"
                                :menu-props="{'max-width': '0px', 'min-width': '468px'}"
                                clearable
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <p class="mt-6 mb-2 filter-label">Data</p>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterStartDate"
                                        label="De"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filterStartDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                left
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterFinalDate"
                                        label="Até"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filterFinalDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </filter-drawer>
    </v-card>
</template>

<script>
import ReportCards from "./BookingReportResults.vue";
import FilterDrawer from "../FilterDrawer.vue";
import moment from "moment";

export default {
    name: "BookingReport",

    components: {
        FilterDrawer,
        ReportCards
    },

    props: {
        awaitingReportDownload: {
            type: Boolean,
            default: false
        },
    },

    data: () => ({
        filter: {},
        filterDrawer: '',
        filterHotel: '',
        filterPointOfSale: '',
        filterStartDate: '',
        filterFinalDate: '',
        filterStartDateCalendar: '',
        filterFinalDateCalendar: '',
        bookingReportData: [],
        bookingLoading: true,
        hotelLoading: false,
        pointOfSaleLoading: false,
        hotelList: [],
        pointOfSaleList: [],
        filterHotelId: '',
        filterPointOfSaleId: '',
        filteredResult: false,
        query: '',
    }),

    methods: {
        formatDate(dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },

        formatDateToFilter(date) {
            let formattedDate = '';
            if (date) {
                let dateSplit = date.split('/');
                if (dateSplit[2] && dateSplit[1]) {
                    formattedDate = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`
                    return formattedDate;
                }
            }
            return date;
        },

        clearFilter() {
            this.filterHotel = '';
            this.filterPointOfSale = '';
            this.filterStartDate = '';
            this.filterFinalDate = '';
            this.filterStartDateCalendar = '';
            this.filterFinalDateCalendar = '';
            this.filterHotelId = '';
            this.filterPointOfSaleId = '';
            this.applyFilter();
        },

        applyFilter() {
            this.setFilter();
            this.getBookingReportData();
            this.filterDrawer = !this.filterDrawer;
        },

        setFilter() {
            this.filter = {
                'hotelId': this.filterHotelId,
                'pointOfSaleId': this.filterPointOfSaleId,
                'startDate': this.formatDateToFilter(this.filterStartDate),
                'finalDate': this.formatDateToFilter(this.filterFinalDate),
            };
            this.filteredResult = this.resultIsFiltered(this.filter);
            this.$emit('apply-filter', this.filter);
        },

        pushQueryToRouter() {
            this.$router.push({
                query: {
                    'hotelId': this.filter.hotelId,
                    'pointOfSaleId': this.filter.pointOfSaleId,
                    'startDate': this.filter.startDate,
                    'finalDate': this.filter.finalDate,
                }
            });
        },

        setQueryString() {
            this.query = `hotelId=${this.filter.hotelId}&pointOfSaleId=${this.filter.pointOfSaleId}&startDate=${this.filter.startDate}&finalDate=${this.filter.finalDate}`;
        },

        getBookingReportData() {
            this.bookingLoading = true;
            this.setFilter();
            this.pushQueryToRouter();
            this.setQueryString();
            axios.get(`/api/reports/booking?${this.query}`)
                .then(res => {
                    this.bookingReportData = res.data[0];
                    this.bookingLoading = false;
                })
        },

        listHotels() {
            if (this.filterHotel && this.filterHotel.length === 5) {
                this.hotelLoading = true;
                let query = `paginate=false&hotelName=${this.filterHotel}`;
                axios.get(`/api/hotel/list?${query}`)
                    .then(res => {
                        this.hotelList = res.data;
                        this.hotelLoading = false;
                    });
            }
        },

        listPointsOfSale() {
            this.pointOfSaleLoading = true;
            let query = `list=true`;
            axios.get(`/api/point-of-sale?${query}`)
                .then(res => {
                    this.pointOfSaleList = res.data;
                    this.pointOfSaleLoading = false;
                });
        },

        pointOfSaleText(item) {
            return item.id + ' - ' + item.name;
        },

        resultIsFiltered(filter) {
            for (let filterKey in filter) {
                if (filter[filterKey]) {
                    return true;
                }
            }
            return false;
        },

        getFilterFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    hotelId,
                    pointOfSaleId,
                    startDate,
                    finalDate,
                } = this.$route.query;
                if (hotelId) {
                    this.filterHotelId = hotelId;
                }
                if (pointOfSaleId) {
                    this.filterPointOfSaleId = pointOfSaleId;
                }
                if (startDate) {
                    this.filterStartDate = startDate;
                }
                if (finalDate) {
                    this.filterFinalDate = finalDate;
                }
            }
        },

        get30DaysAgoDate() {
            let priorDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T');
            return priorDate[0];
        },

        getTodayDate() {
            let today = new Date().toISOString().split('T');
            return today[0];
        },

        setDefaultFilterLast30Days() {
            if (this.filterStartDate === '') {
                this.filterStartDate = this.formatDate(this.get30DaysAgoDate());
            }
            if (this.filterFinalDate === '') {
                this.filterFinalDate = this.formatDate(this.getTodayDate());
            }
        },

        emitDownloadReport () {
            this.$emit('download-report');
        },
    },

    mounted() {
        this.getFilterFromUrlQuery();
        this.setDefaultFilterLast30Days();
        this.getBookingReportData();
        this.listPointsOfSale();
    },

    watch: {
        filterStartDateCalendar: function(date) {
            this.filterStartDate = this.formatDate(date);
        },
        filterFinalDateCalendar: function(date) {
            this.filterFinalDate = this.formatDate(date);
        },
        filterHotel: function() {
            this.listHotels();
        },
    },
}
</script>

<style scoped>
.filter-btn {
    color: #FFF;
}

.filter-label {
    font-size: 18px;
    color: #333;
}

.v-autocomplete__content {
    width: 160px;
}
</style>
